"use client"; // Error boundaries must be Client Components

import { useEffect } from "react";
import type { ErrorPageProps } from "@repo/types";
import { LogotypeIcon } from "#/components/atoms/icon-logotype";
import { Button } from "@repo/components/atoms/shadcn/button";
import logger from "@repo/logger";

export default function Error({
  error,
  reset,
}: ErrorPageProps): React.ReactNode {
  useEffect(() => {
    // Log the error to an error reporting service
    logger.error(error);
  }, [error]);

  return (
    <>
      <div className="mx-4 my-16 grid h-96 place-content-center place-items-center gap-8">
        <LogotypeIcon className="w-96 fill-foreground" />
        <h2 className="heading-2">An error occurred</h2>
        <p>An error occurred while trying to access the requested resource</p>
        <Button
          variant="default"
          size="lg"
          onClick={
            // Attempt to recover by trying to re-render the segment
            () => {
              reset();
            }
          }
        >
          Try again
        </Button>
      </div>
    </>
  );
}
